import { render, staticRenderFns } from "./today-hot.vue?vue&type=template&id=3f50c57c&scoped=true"
import script from "./today-hot.vue?vue&type=script&lang=js"
export * from "./today-hot.vue?vue&type=script&lang=js"
import style0 from "./today-hot.vue?vue&type=style&index=0&id=3f50c57c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f50c57c",
  null
  
)

export default component.exports